import { BreadCrumbModel } from '@/modules/shared/models/breadcrumb';
import i18n from '@/plugins/i18n';

const Breadcrumbs = {
  awaitingPayment: [{
    text: i18n.t('payment.paymentStatus'),
    href: '/payment/awaiting-payment',
  }] as BreadCrumbModel[],

  failedPayment: [{
    text: i18n.t('payment.paymentStatus'),
    href: '/payment/failed/:id',
  }] as BreadCrumbModel[],

  cancelledPayment: [{
    text: i18n.t('payment.paymentStatus'),
    href: '/payment/cancelled',
  }] as BreadCrumbModel[],

  successPayment: [{
    text: i18n.t('payment.paymentStatus'),
    href: '/payment/success',
  }] as BreadCrumbModel[],

  underProcessing: [{
    text: i18n.t('payment.paymentStatus'),
    href: '/under-processing',
  }] as BreadCrumbModel[],
};

export default Breadcrumbs;
